import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';
export var recommendationActions;
(function (recommendationActions) {
    recommendationActions["RECO_REQUEST"] = "RECO_REQUEST";
    recommendationActions["RECO_SUCCESS"] = "RECO_SUCCESS";
    recommendationActions["RECO_ERROR"] = "RECO_ERROR";
    recommendationActions["RECO_RESET"] = "RECO_RESET";
})(recommendationActions || (recommendationActions = {}));
export function resetRecommendations(widgetType) {
    return (dispatch) => dispatch({
        type: recommendationActions.RECO_RESET,
        widgetType
    });
}
export function fetchRecommendations(requestContext = {
    start: 0,
    contentIds: []
}, url, widgetType) {
    return (dispatch) => {
        dispatch({
            type: recommendationActions.RECO_REQUEST,
            widgetType
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: `/api${url}`,
            action: recommendationActions.RECO_REQUEST
        }), requestContext)
            .then(json => {
            return dispatch({
                type: recommendationActions.RECO_SUCCESS,
                widgetType,
                data: json['RESPONSE'],
                start: (requestContext.start || 0) + requestContext.contentIds.length,
                contentIds: requestContext.contentIds
            });
        })
            .catch(error => dispatch({
            type: recommendationActions.RECO_ERROR,
            widgetType,
            error
        }));
    };
}
